import React from "react";


function Administration() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/slider/slider-1.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
        <h1>Administrative Members</h1>
        <div className="row">
            <div className="col-md-12">
                <div className="row" style={{marginBottom:'50px'}}>
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/babu-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">V ബാബു</p>
                            <p className="designation">പ്രസിഡന്റ്‌  <br />
                                <span className="phone-1">Ph: 9961472384 </span></p>
                            
                        </div>
                    </div>  
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/secretary-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">K ശശിധരൻ</p>
                            <p className="designation">സെക്രട്ടറി  <br />
                                <span className="phone-1">Ph: 9249752890 </span></p>
                        </div>
                    </div>  
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/sunu-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">സജു സുകുമാരൻ</p>
                            <p className="designation">ട്രഷറര്‍ <br />
                                <span className="phone-1">Ph: 9895141722 </span></p>
                        </div>
                    </div>  
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/rajeev-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">രാജീവ്‌ R</p>
                            <p className="designation">വൈസ് പ്രസിഡന്റ്‌  <br />
                                <span className="phone-1">Ph: 8590514075 </span>
                            </p>
                        </div>
                    </div>  
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/vipin-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">വിപിൻ M</p>
                            <p className="designation">ജോയിൻ സെക്രട്ടറി   <br />
                                <span className="phone-1">Ph: 9895530179 </span></p>
                        </div>
                    </div>                  
                </div>
           </div>            
        </div>

        <div className="row">
            <div className="col-md-12">
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/vishnu-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">വിഷ്ണു v s</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>   
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/jayendran.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">ജയെന്ദ്രൻ v</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>  
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/satheesh-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">സതീഷ് കുമാർ v</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/sanal-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">സനൽ കുമാർ s</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>     
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/anilkumar-1.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">അനിൽകുമാർ k</p>
                             <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/biju.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">ബിജു S</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/mahesh.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">മഹേഷ് M R</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>    
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/vineeth.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">വിനീത് M</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>  
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/mohanan.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">മോഹനൻ V</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/raveendran.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">രവീന്ദ്രൻ V</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>   
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/jayaraj.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">ജയരാജ് J</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/pramod.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">പ്രമോദ് കുമാർ K L</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div> 
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/mukundan.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">മുകുന്ദൻ. R</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>  
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/hiran.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">ഹിരൺ രാജ്  R</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>  
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/shibu.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">ഷിബു M</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>  
                     <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/suresh.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">സുരേഷ് കുമാർ K</p>
                            <p className="designation">ഭരണസമിതി അംഗം </p>
                        </div>
                    </div>               
                </div>
           </div>            
        </div>

         <div className="row" style={{borderTop:'5px solid orange',paddingTop:'50px',background:'orange',borderRadius:'15px'}}>
             <div className="col-md-12">
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/thanthri.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">തന്ത്രരത്നം പ്രശാന്ത് ജി നമ്പുതിരി  </p>
                            <p className="designation">ക്ഷേത്രതന്ത്രി</p>
                        </div>
                    </div>   
                    {/* <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/melsanthi.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">മാധവൻ നമ്പൂതിരി</p>
                            <p className="designation">മേൽശാന്തി</p>
                        </div>
                    </div>   */}
                     
                </div>

             </div>
         </div>

        <div className="row">
            <div className="col-md-12">
                <div className="row" style={{marginBottom:'50px'}}>
                                      
                </div>
           </div>            
        </div>
</div>
    </div>
  );
}

export default Administration;